import GlobalBannersModalBase from './ModalBase';
import GlobalBannersFreePremiun from './FreePremiun';
import GlobalBannersFreePremiunFor30Days from './FreePremiunFor30Days';

const GlobalBannersComponents = {
  ModalBase: GlobalBannersModalBase,
  FreePremiun: GlobalBannersFreePremiun,
  FreePremiunFor30Days: GlobalBannersFreePremiunFor30Days,
};

export default GlobalBannersComponents;
